import script from "./RcItemCardAction.vue?vue&type=script&setup=true&lang=ts"
export * from "./RcItemCardAction.vue?vue&type=script&setup=true&lang=ts"

import "./RcItemCardAction.vue?vue&type=style&index=0&id=3804448b&lang=scss"

const __exports__ = script;

export default __exports__